import {call, fork, put, select, take} from "redux-saga/effects";
import {userFilters, userPageParams} from "../../reducers/users";
import API from "../../api/api";
import {getCurrentStore, getUserInfo} from "../../reducers/app";
import {CODES} from "../../constants";
import {addUserReq, changeUserReq, deleteUserReq} from "../../api/types";
import {toast} from "react-toastify";
import {globalIntl} from "../App/App";

export function *getUserList(object?: any): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    let filters = {...yield select(userFilters)}
    for (var key in filters){
        if(filters[key] === -1 || !filters){
            filters[key] = null
        }
    }
    let pageParams = yield select(userPageParams)
    let currentStore = yield select(getCurrentStore)

    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...pageParams,
        ...filters,
        ...(object ? object.pageParams : {}),
        storeId: currentStore
    }
    let resp = yield call(API.getUserList, params)
    if(resp.code === CODES.SUCCESS && resp.data){
        yield put({type: 'SET_USER_LIST', payload: {data: resp.data, pageParams: object ? object.pageParams : {}}})
    }
}

export function *addUser(data: addUserReq): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    if(data.storeId === -1) {
        data.storeId = undefined
    }

    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...data,
        userEmail: data.loginNo
    }
    let resp = yield call(API.addUser, params)
    if(resp.code === CODES.SUCCESS && resp.data){
        toast.success(globalIntl.formatMessage({id: 'addUserSucc'}))
        yield fork(getUserList, {pageParams:{currentPage: 1}})
    }
}

export function *deleteUser(data: deleteUserReq): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    let params = {
        ...data,
        email: userInfo.email,
        clientId: 'h5',
    }
    let resp = yield call(API.deleteUser, params)
    if(resp.code === CODES.SUCCESS){
        toast.success(globalIntl.formatMessage({id: 'deleteSucc'}))
        yield fork(getUserList, {pageParams:{currentPage: 1}})
    }
}

export function *modifyuser(data: changeUserReq): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...data,
        userEmail: data.loginNo
    }
    let resp = yield call(API.modifyUser, params)
    if(resp.code === CODES.SUCCESS){
        if(data.loginNo !== userInfo.email){
            let userInfoStorage = yield localStorage.getItem('S4P_UserInfo');
            let json = JSON.parse(userInfoStorage)
            if(data.cashierNo === userInfo.cashierNo){
                yield put({type: 'USER_EMAIL_CHANGE', payload: {email: data.loginNo}})
                json['email'] = data.loginNo
                yield localStorage.setItem('S4P_UserInfo', JSON.stringify(json))
            }
        }
        toast.success(globalIntl.formatMessage({id: 'modifySucc'}))
        yield fork(getUserList, {pageParams:{currentPage: 1}})

    }
}

export function *watchUsers(){
    while (true) {
        let {payload} = yield take('GET_USERS')
        yield fork(getUserList, payload)

    }
}

export function *watchUserChange(){
    while (true) {
        let {payload} = yield take('USER_CHANGE')
        if(payload.changeType === 'add'){
            yield fork(addUser, payload.data)
        }else if(payload.changeType === 'delete'){
            yield fork(deleteUser, payload.data)
        }else if(payload.changeType === 'change'){
            yield fork(modifyuser, payload.data)
        }
    }
}

